import { withStyles } from '@material-ui/core/styles';
import MoodIcon from '@material-ui/icons/Mood';
import MoodBadIcon from '@material-ui/icons/MoodBad';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { STATUS_ACCEPTED, STATUS_DRAFT, STATUS_REJECTED } from './utils/constants';

const DRAFT = STATUS_DRAFT;
const REJECTED = STATUS_REJECTED;
const APPROVED = STATUS_ACCEPTED;

class SlatInnerWorkflow extends React.Component {

    render() {

        const { classes, workflowStatus, } = this.props;

        return (
            <div className={classes.slatInner}
                style={{ marginLeft: '-26px', width: '26px' }}>
                {workflowStatus === DRAFT &&
                    <NewReleasesIcon data-test="draft-icon" style={{ color: '#e5e5e5', transform: 'translateY(3px)' }} />
                }
                {workflowStatus === APPROVED &&
                    <MoodIcon data-test="approved-icon" style={{ color: '#e5e5e5', transform: 'translateY(3px)' }} />
                }
                {workflowStatus === REJECTED &&
                    <MoodBadIcon data-test="rejected-icon" style={{ color: '#DD2C00', transform: 'translateY(3px)' }} />
                }
            </div>
        );
    }
}

SlatInnerWorkflow.defaultProps = {
    workflowStatus: undefined
};

SlatInnerWorkflow.propTypes = {
    workflowStatus: PropTypes.string,
    classes: PropTypes.object
};

export default withStyles(styles)(SlatInnerWorkflow);